<template>
  <div class="header-base-menu">
    <nuxt-link
      v-for="(button, idx) in buttons"
      :key="button.label"
      class="header-base-menu__item"
      :to="localizePath(button.pageUrl)"
      :class="[
        'header-base-menu__link',
        {
          'header-base-menu__link_active':
            route.path === localizePath(button.pageUrl) || (!idx && additionalCasinoActive),
        },
      ]"
      @mouseenter="handleMouseEnter(button.label)"
      @mouseleave="handleMouseLeave(button.label)"
    >
      <!-- Клиентский wrapper для видео -->
      <client-only>
        <atomic-video-switcher
          :ref="el => setVideoRef(el, button.label)"
          :video-on="button.videoOn"
          :video-off="button.videoOff"
          :poster-on="button.posterOn"
          :poster-off="button.posterOff"
          class="header-base-menu__video"
        />
        <template #fallback>
          <img
            :src="button.posterOn"
            :data-src="button.posterOn"
            :alt="getContent(layoutData, defaultLocaleLayoutData, `header.headerButtons.${button.label}`)"
            class="header-base-menu__image"
            data-not-lazy
          >
        </template>
      </client-only>

      <div class="header-base-menu__text">
        {{ getContent(layoutData, defaultLocaleLayoutData, `header.headerButtons.${button.label}`) }}
      </div>
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
interface VideoSwitcherComponent extends ComponentPublicInstance {
  playAnimation: (type: 'On' | 'Off') => void;
}
const route = useRoute();
const { localizePath, getContent } = useProjectMethods();
const { layoutData, defaultLocaleLayoutData } = useGlobalStore();

const {
  public: { gamehubCdn },
} = useRuntimeConfig();

const sourcePath = `${gamehubCdn}/video/animations/header-menu/`;

const buttons = [
  {
    label: 'games',
    videoOn: `${sourcePath}dice-on.webm`,
    videoOff: `${sourcePath}dice-off.webm`,
    posterOn: `${sourcePath}dice-on-ph.webp`,
    posterOff: `${sourcePath}dice-off-ph.webp`,
    pageUrl: '/games',
  },
  {
    label: 'sports',
    videoOn: `${sourcePath}ball-on.webm`,
    videoOff: `${sourcePath}ball-off.webm`,
    posterOn: `${sourcePath}ball-on-ph.webp`,
    posterOff: `${sourcePath}ball-off-ph.webp`,
    pageUrl: '/sport',
  },
];

const videoComponentRefs = ref<Record<string, VideoSwitcherComponent | null>>({});

const isVideoSwitcherComponent = (el: Element | ComponentPublicInstance | null): el is VideoSwitcherComponent => {
  return el !== null && '$el' in el && 'playAnimation' in el;
};

const setVideoRef = (el: Element | ComponentPublicInstance | null, label: string) => {
  if (isVideoSwitcherComponent(el)) {
    videoComponentRefs.value[label] = el;
  }
};

const handleMouseEnter = (label: string) => {
  const videoComponent = videoComponentRefs.value[label];
  if (videoComponent) {
    videoComponent.playAnimation('On');
  }
};

const handleMouseLeave = (label: string) => {
  const videoComponent = videoComponentRefs.value[label];
  if (videoComponent) {
    videoComponent.playAnimation('Off');
  }
};
const additionalCasinoActive = computed(() => {
  const routeName = route.name as string;
  return !!route.query.category || routeName?.includes('games-id');
});
</script>

<style src="~/assets/styles/components/layout/header-base-menu.scss" lang="scss" />
